var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mb-6",
            attrs: {
              type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
              boilerplate: "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", [
            _vm.billing.balance
              ? _c(
                  "div",
                  {
                    staticClass: "absolute",
                    staticStyle: { top: "31px", right: "16px" },
                  },
                  [
                    _c("small", [_vm._v("Account Balance")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "soli-grey flex justify-end" }, [
                      _vm._v(
                        "\n                $" +
                          _vm._s(_vm.getAccountBalance) +
                          "\n            "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-expansion-panels",
            {
              attrs: { flat: "" },
              on: {
                change: function ($event) {
                  return _vm.$emit("change")
                },
              },
              model: {
                value: _vm.panel,
                callback: function ($$v) {
                  _vm.panel = $$v
                },
                expression: "panel",
              },
            },
            _vm._l(_vm.billing.transactions, function (item, idx) {
              return _c(
                "v-expansion-panel",
                {
                  key: item.id,
                  class: ["soli-round mb-2 mt-0", `panel-${idx}`],
                },
                [
                  _c(
                    "v-expansion-panel-header",
                    {
                      class: ["soli-round mb-2 py-0"],
                      attrs: {
                        "expand-icon": "keyboard_arrow_down",
                        focusable: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$log(item.id)
                        },
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { class: ["align-center soli-grey"] },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pl-0" },
                            [
                              _c("v-list", { staticClass: "mx-2" }, [
                                _c("div", { staticClass: "caption" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.globalMomentFullDateAtTimeShort(
                                          item.date
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "flex align-center",
                                      _vm.$vuetify.breakpoint.xsOnly
                                        ? "body-2"
                                        : "body-1",
                                    ],
                                  },
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        class: [
                                          "mr-3 white--text font-bold first-letter",
                                          item.color,
                                        ],
                                        attrs: { "x-small": "" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.status) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.formatUnitAmount(item.amount)
                                        ) +
                                        "\n                            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "caption flex align-center gap-1",
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("storefront"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          `${item.location.name} ${
                                            item.payment
                                              ? " | " + item.payment
                                              : ""
                                          }`
                                        ) +
                                        "\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "v-row",
                        { staticClass: "justify-around align-center" },
                        [
                          item.lastAttempt && item.failed
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-col justify-start flex pt-3 px-3",
                                },
                                [
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass:
                                        "soli-grey font-weight-bold align-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Last Attempt:\n                            "
                                      ),
                                      _c(
                                        "v-chip",
                                        {
                                          class: [
                                            "mx-1 white--text font-bold soli-status-red",
                                          ],
                                          staticStyle: {
                                            transform: "translateY(-1px)",
                                          },
                                          attrs: { "x-small": "", right: "" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Failed\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.lastAttempt.method)
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "soli-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        `${_vm.globalMomentDateAtTimeDots(
                                          item.lastAttempt.date
                                        )}`
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-full body-2 pa-3" },
                            [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "soli-grey font-weight-bold" },
                                [_vm._v("Purchases")]
                              ),
                              _vm._v(" "),
                              _vm._l(item.description, function (line, i) {
                                return _c(
                                  "div",
                                  { key: i, staticClass: "soli-grey" },
                                  [
                                    _vm._v(
                                      "\n                            · " +
                                        _vm._s(line) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              item.discounts.length
                                ? _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass:
                                        "soli-grey font-weight-bold mt-1",
                                    },
                                    [_vm._v("Discounts")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(item.discounts, function (discount, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: discount + idx,
                                    staticClass: "soli-grey",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            · " +
                                        _vm._s(discount) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-full flex pa-3 mb-4 justify-space-around",
                            },
                            [
                              _vm.can("Issue refunds and credits")
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        color: "dark",
                                        disabled:
                                          !item.paid ||
                                          item.refunded ||
                                          item.amount == 0 ||
                                          !item.charge ||
                                          !_vm.viewAtTransactionLocation(item),
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            (_vm.refundForm.charge =
                                              item.charge),
                                            (_vm.refundForm.amount =
                                              (item.amount - item.refunds) /
                                              100),
                                            (_vm.refundMax =
                                              (item.amount - item.refunds) /
                                              100),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("restore")]),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "mt-1 panel-text" },
                                        [_vm._v("Refund")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    href: item.receipt_url,
                                    icon: "",
                                    small: "",
                                    color: "dark",
                                    disabled: !item.paid,
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticStyle: { display: "block" } },
                                    [_vm._v("visibility_on")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    { staticClass: "mt-1 panel-text" },
                                    [_vm._v("View")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    color: "dark",
                                    disabled:
                                      item.paid || item.upcoming || item.void,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$page.props.staffView
                                        ? (_vm.showPaymentOptions = item)
                                        : _vm.visitInvoiceUrl(item)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [_vm._v("payments")]),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "mt-1 panel-text",
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [_vm._v("Pay Now")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.user.billingPortal
        ? _c("v-row", { attrs: { "no-gutters": "" } }, [
            _c(
              "a",
              {
                staticClass: "caption flex justify-end py-3 px-6",
                attrs: { href: _vm.user.billingPortal },
              },
              [_vm._v("View All")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.refundForm.charge
        ? _c("SoliForm", {
            ref: "refundForm",
            attrs: {
              title: "Refund",
              textSubtitle:
                "Refunds take 5-10 days to appear on a customer's statement.",
              text: "Process Refund",
              icon: "save",
            },
            on: {
              submit: _vm.refundTransaction,
              reset: function ($event) {
                return _vm.resetForm(_vm.refundForm)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Amount",
                          rules: _vm.refundRules,
                          outlined: "",
                          dense: "",
                          "error-message": "errors.amount",
                        },
                        model: {
                          value: _vm.refundForm.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.refundForm, "amount", $$v)
                          },
                          expression: "refundForm.amount",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "soli-round",
                        attrs: {
                          items: _vm.refundReasons,
                          "item-text": "text",
                          "item-value": "value",
                          label: "Reason",
                          dense: "",
                          outlined: "",
                          rules: [(v) => !!v || "You must provide a reason"],
                        },
                        model: {
                          value: _vm.refundForm.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.refundForm, "reason", $$v)
                          },
                          expression: "refundForm.reason",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1967150456
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreditForm
        ? _c("SoliForm", {
            ref: "creditForm",
            attrs: {
              title: "Adjust Account Balance",
              text: _vm.chargeCustomer ? "Charge" : "Save",
              icon: _vm.chargeCustomer ? "credit_card" : "save",
            },
            on: {
              submit: _vm.addCredit,
              reset: function ($event) {
                _vm.showCreditForm = false
              },
              "hook:mounted": function ($event) {
                ;[
                  (_vm.creditForm.customer = _vm.user.id),
                  (_vm.creditForm.adjust = true),
                ]
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "px-2 mb-6 soli-round" }, [
                        _c("small", [_vm._v("Current Balance")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "soli-grey soli-subtitle" }, [
                          _vm._v(
                            "\n                    $" +
                              _vm._s(_vm.getAccountBalance) +
                              "\n                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: [
                            { text: "Credit", value: true },
                            { text: "Debit", value: false },
                          ],
                          label: "Credit/Debit",
                          outlined: "",
                          "prepend-inner-icon": _vm.creditForm.adjust
                            ? "savings"
                            : "credit_card",
                          dense: "",
                          rules: [
                            (v) => v !== null || "This field is required",
                          ],
                        },
                        model: {
                          value: _vm.creditForm.adjust,
                          callback: function ($$v) {
                            _vm.$set(_vm.creditForm, "adjust", $$v)
                          },
                          expression: "creditForm.adjust",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-currency-field", {
                        staticClass: "soli-round",
                        attrs: {
                          label: "Amount",
                          rules: _vm.creditRules,
                          outlined: "",
                          dense: "",
                          "prepend-inner-icon": "attach_money",
                          "error-message": "errors.amount",
                        },
                        model: {
                          value: _vm.creditForm.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.creditForm, "amount", $$v)
                          },
                          expression: "creditForm.amount",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.chargeCustomer
                        ? _c("v-textarea", {
                            staticClass: "soli-round",
                            attrs: {
                              outlined: "",
                              dense: "",
                              label: "Add a note for this adjustment",
                              "prepend-inner-icon": "notes",
                              counter: "255",
                              rules: [
                                (v) => !!v || "You must provide a reason",
                                (v) =>
                                  v?.length < 255 ||
                                  "Note must be less than 255 characters",
                              ],
                            },
                            model: {
                              value: _vm.creditForm.note,
                              callback: function ($$v) {
                                _vm.$set(_vm.creditForm, "note", $$v)
                              },
                              expression: "creditForm.note",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.chargeCustomer
                        ? _c("v-text-field", {
                            staticClass: "soli-round",
                            attrs: {
                              outlined: "",
                              dense: "",
                              label: "Invoice Item Description",
                              "prepend-inner-icon": "short_text",
                              counter: "50",
                              rules: [
                                (v) =>
                                  !!v ||
                                  "You must provide a short description for the charge" ||
                                  v.length < 50 ||
                                  "Description must be less than 50 characters",
                              ],
                            },
                            model: {
                              value: _vm.creditForm.note,
                              callback: function ($$v) {
                                _vm.$set(_vm.creditForm, "note", $$v)
                              },
                              expression: "creditForm.note",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.chargeCustomer
                        ? _c(
                            "div",
                            { staticClass: "soli-grey text-subtitle-2" },
                            [
                              _c("p", { staticClass: "px-1 mb-4" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(`This amount exceeds the client balance. This will
                    immediately create an invoice for the customer and
                    charge their default payment method ${_vm.chargeAmount}`) +
                                    ".\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  rules: [
                                    (v) =>
                                      !!v ||
                                      `Please confirm that you want to charge the customer's default payment method`,
                                  ],
                                  label: "I Understand",
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.creditForm.understand,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.creditForm, "understand", $$v)
                                  },
                                  expression: "creditForm.understand",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1113682603
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGiftForm
        ? _c("SoliForm", {
            ref: "giftForm",
            attrs: { title: "Redeem Gift or Promotion" },
            on: {
              submit: _vm.redeemGift,
              reset: function ($event) {
                _vm.showGiftForm = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "SoliText",
                        {
                          attrs: {
                            label: "Redemption Code",
                            errors: _vm.errors.code || _vm.errors.promo,
                            "hide-details": "auto",
                            rules: [
                              (val) =>
                                (val || "").length > 0 ||
                                "This field is required",
                            ],
                          },
                          model: {
                            value: _vm.giftForm.redemptionCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.giftForm, "redemptionCode", $$v)
                            },
                            expression: "giftForm.redemptionCode",
                          },
                        },
                        [_vm._v("Redemption Code")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3024632536
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPaymentOptions
        ? _c("SoliChoice", {
            attrs: {
              title: "Payment Options",
              button1: "Pay Online",
              button2: "Pay By Check",
              link1: _vm.showPaymentOptions.invoice_url,
            },
            on: {
              option2: function ($event) {
                _vm.getCheckNumber = _vm.showPaymentOptions
              },
              reset: function ($event) {
                _vm.closeModal((e) => (_vm.showPaymentOptions = null))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getCheckNumber
        ? _c("SoliForm", {
            attrs: { title: "Record check number" },
            on: {
              reset: function ($event) {
                _vm.closeModal((e) => (_vm.getCheckNumber = null))
              },
              submit: function ($event) {
                return _vm.payByCheck(_vm.getCheckNumber)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliText", {
                        attrs: {
                          label: "Check #",
                          number: "",
                          rules: [
                            (val) =>
                              (val || "").length > 0 ||
                              "This field is required",
                          ],
                        },
                        model: {
                          value: _vm.getCheckNumber.checkNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.getCheckNumber, "checkNumber", $$v)
                          },
                          expression: "getCheckNumber.checkNumber",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2984119237
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }